import { render, staticRenderFns } from "./safe4_classification.vue?vue&type=template&id=4e4637ce&scoped=true"
import script from "./safe4_classification.vue?vue&type=script&lang=js"
export * from "./safe4_classification.vue?vue&type=script&lang=js"
import style0 from "./safe4_classification.vue?vue&type=style&index=0&id=4e4637ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e4637ce",
  null
  
)

export default component.exports